module.exports = __webpack_public_path__ + "static/media/msgNotification.71aa6a2e.mp3";